import Channel from '../';

export default class ThingSpeakChannel extends Channel {
  last_entry_id = '';
  ranking = 0;
  username = '';
  tags = [];
  constructor(initializer = {}) {
    super(initializer);
  }
}



// WEBPACK FOOTER //
// ./src/models/channel/thingSpeak/ThingSpeakChannel.js